/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { useMutation } from "@apollo/client/react"
import { Eye, X } from "lucide-react"
import { type FC } from "react"
import { StopViewAsDocument } from "../../services/__generated__/graphql"
import { clearViewAs, getViewAs } from "../../services/impersonation"

const s = {
  bar: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    flex-shrink: 0;
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
    color: #78350f;
    background: #fde68a;
    border-bottom: 1px solid #f59e0b;
    z-index: 30;
  `,
  exit: css`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    margin-left: 0.5rem;
    padding: 0.125rem 0.5rem;
    border-radius: 0.3rem;
    border: 1px solid #b45309;
    background: transparent;
    color: #78350f;
    font-size: 0.75rem;
    cursor: pointer;
    &:hover {
      background: #fcd34d;
    }
  `,
}

/** Persistent bar shown while a View As session is active. Exiting stops the
 *  session (audited) and reloads back into the operator's own view. */
export const ViewAsBanner: FC = () => {
  const viewAs = getViewAs()
  const [stopViewAs] = useMutation(StopViewAsDocument)

  if (!viewAs) return null

  const handleExit = async () => {
    try {
      await stopViewAs({ variables: { token: viewAs.token } })
    } catch {
      // Exiting must never be blocked by a failed stop call.
    }
    clearViewAs()
    window.location.reload()
  }

  return (
    <div css={s.bar} role="status">
      <Eye size={14} />
      <span>
        Viewing as <strong>{viewAs.targetEmail || "user"}</strong>
      </span>
      <button css={s.exit} onClick={handleExit}>
        <X size={13} />
        Exit
      </button>
    </div>
  )
}
